import widgetsService from 'live/services/widgets'
import i18n from 'live/services/i18n'
import chartReducer from './chartReducer'
import ChartWidget from './ChartWidget'
import { widgetWrapper } from 'live/widgets/decorators/pure'
import React from 'react'

const type = 'bar-chart'

widgetsService.impl(
    type,
    widgetWrapper(ChartWidget, chartReducer, {
        mapConfigToRender(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext.theme
            }
        },
        sampleTime: 500
    })
)

widgetsService.name(type, 'Chart Widget')

widgetsService.policies(type, {
    layers: 1,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) at the end => @chain',
    handleOwnMissingData: true
})

widgetsService.properties(type, {})

widgetsService.config(type, {
    verticalEnabled: false,
    numberOfVisibleAxes: 6
})

export default type
